<template>
  <v-container id="feedbacks" fluid tag="section" class="dashboard-container" style="padding: 24px 96px;">
    <!-- Header Row (Design Refatorado SaaS Clean Premium) -->
    <v-row class="mb-2 ma-n2" align="center">
      <v-col cols="12" sm="auto" class="pa-2">
        <div class="d-flex align-center">
          <h1 class="text-h4 font-weight-bold text--primary">Feedbacks</h1>
        </div>
        <p class="text-caption text--secondary mt-1">Acompanhe seus elogios e pontos de melhoria</p>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="auto" class="pa-2">
        <v-btn
          v-if="!isViewOnlyMode"
          color="#00E5FF"
          height="40"
          depressed
          class="px-5 font-weight-bold action-btn black--text"
          style="border-radius: 8px;"
          @click="openSendDialog"
        >
          <v-icon left color="black">mdi-plus</v-icon> Enviar Feedback
        </v-btn>
      </v-col>
    </v-row>

    <!-- Cards de Estatísticas (Design Premium SaaS Rework - Sem borda lateral) -->
    <v-row class="mb-4 ma-n2 mt-2 top-cards-row">
      <v-col cols="12" md="6" class="pa-2 d-flex">
        <v-card class="pa-4 elevment-card elevation-0 top-card flex-grow-1">
          <div class="d-flex align-center flex-grow-1 justify-space-between" style="height: 100%">
            <!-- Ícone Tonal Box -->
            <v-avatar color="rgba(76, 175, 80, 0.12)" size="48" class="mr-4 elevation-0">
              <v-icon color="#4CAF50">mdi-thumb-up-outline</v-icon>
            </v-avatar>
            <!-- Conteúdo de Estatística Alinhado à Direita -->
            <v-card-text class="text-right pa-0 d-flex flex-column align-end justify-center">
              <div class="text-h1 font-weight-bold" style="color: #4CAF50;">{{ receivedPraiseCount }}</div>
              <span class="text-caption text--secondary mt-1">Elogios Recebidos</span>
            </v-card-text>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" class="pa-2 d-flex">
        <v-card class="pa-4 elevment-card elevation-0 top-card flex-grow-1">
          <div class="d-flex align-center flex-grow-1 justify-space-between" style="height: 100%">
            <!-- Ícone Tonal Box -->
            <v-avatar color="rgba(30, 136, 229, 0.12)" size="48" class="mr-4 elevation-0">
              <v-icon color="#1E88E5">mdi-lightbulb-on-outline</v-icon>
            </v-avatar>
            <!-- Conteúdo de Estatística Alinhado à Direita -->
            <v-card-text class="text-right pa-0 d-flex flex-column align-end justify-center">
              <div class="text-h1 font-weight-bold" style="color: #1E88E5;">{{ receivedImprovementCount }}</div>
              <span class="text-caption text--secondary mt-1">Pontos de Melhoria</span>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Filtros e Tabs Soltos no Fundo (Visual Limpo) -->
    <v-row align="center" class="ma-n2 mb-4 mt-2">
      <!-- Segmented Tabs (Preenchimento Ciano Total) -->
      <v-col cols="auto" class="pa-2">
        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          hide-slider
          height="44"
          class="flex-grow-0 segmented-tabs"
          style="max-width: 320px;"
        >
          <v-tab 
            class="text-none font-weight-bold text-body-2 custom-tab-btn" 
            active-class="custom-tab-active"
            :ripple="false"
          >
            Recebidos
            <v-chip 
              v-if="receivedCount > 0" 
              :color="activeTab === 0 ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255,255,255,0.1)'" 
              :class="activeTab === 0 ? 'black--text' : 'grey--text text--lighten-1'"
              x-small 
              class="ml-2 font-weight-bold px-2 elevation-0"
            >
              {{ receivedCount }}
            </v-chip>
          </v-tab>
          
          <v-tab 
            class="text-none font-weight-bold text-body-2 custom-tab-btn" 
            active-class="custom-tab-active"
            :ripple="false"
          >
            Enviados
            <v-chip 
              v-if="sentCount > 0" 
              :color="activeTab === 1 ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255,255,255,0.1)'" 
              :class="activeTab === 1 ? 'black--text' : 'grey--text text--lighten-1'"
              x-small 
              class="ml-2 font-weight-bold px-2 elevation-0"
            >
              {{ sentCount }}
            </v-chip>
          </v-tab>
        </v-tabs>
      </v-col>

      <!-- Divisor e Filtros Pills (Floating style) -->
      <v-col cols="12" sm="auto" class="d-flex align-center pa-2 flex-wrap" style="gap: 8px">
        <v-divider vertical class="mx-2 theme-divider hidden-xs-only" style="height: 40px;" />
        
        <v-btn
          small rounded depressed
          :class="activeTabFilter === 'ALL' ? 'active-filter-pill' : 'inactive-filter-pill'"
          class="text-none font-weight-bold"
          @click="setActiveFilter('ALL')"
        >Todos</v-btn>
        
        <v-btn
          small rounded depressed
          :class="activeTabFilter === 'PRAISE' ? 'active-filter-pill' : 'inactive-filter-pill'"
          class="text-none font-weight-bold"
          @click="setActiveFilter('PRAISE')"
        >Elogios</v-btn>
        
        <v-btn
          small rounded depressed
          :class="activeTabFilter === 'IMPROVEMENT' ? 'active-filter-pill' : 'inactive-filter-pill'"
          class="text-none font-weight-bold"
          @click="setActiveFilter('IMPROVEMENT')"
        >Melhorias</v-btn>

        <v-btn
          small rounded outlined
          color="grey"
          class="text-none font-weight-bold inactive-filter-pill ml-sm-2"
          @click="toggleActiveSort"
        >
          <v-icon left small>{{ activeTabSort === 'DESC' ? 'mdi-sort-clock-descending-outline' : 'mdi-sort-clock-ascending-outline' }}</v-icon>
          {{ activeTabSort === 'DESC' ? 'Mais recentes' : 'Mais antigos' }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- Listagem de Feedbacks (Cards Independentes e Soltos) -->
    <v-row class="ma-n2">
      <v-col cols="12" class="pa-2">
        <v-tabs-items v-model="activeTab" class="transparent-bg">
          
          <!-- TAB 1: RECEBIDOS -->
          <v-tab-item>
            <div v-if="loadingReceived" class="text-center py-12 elevment-card elevation-0">
              <v-progress-circular indeterminate color="#00E5FF" size="48" width="3" />
              <p class="mt-4 text-body-2 text--secondary">Carregando feedbacks...</p>
            </div>

            <div v-else-if="filteredReceivedFeedbacks.length > 0">
              <!-- Card de Feedback Individual Solto -->
              <v-card
                v-for="feedback in filteredReceivedFeedbacks"
                :key="feedback.id"
                class="elevment-card elevation-0 mb-4 list-card"
              >
                <v-card-text class="pa-5 d-flex flex-column flex-sm-row">
                  <!-- Avatar -->
                  <v-avatar :color="feedback.type === 'PRAISE' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(30, 136, 229, 0.1)'" size="48" class="mr-4 mb-3 mb-sm-0 flex-shrink-0">
                    <v-img v-if="!feedback.isAnonymous && feedback.fromUserAvatarUrl" :src="feedback.fromUserAvatarUrl" :alt="feedback.fromUserName" />
                    <span v-else class="font-weight-bold text-subtitle-1" :style="{ color: feedback.type === 'PRAISE' ? '#4CAF50' : '#1E88E5' }">
                      {{ feedback.isAnonymous ? '?' : getInitials(feedback.fromUserName) }}
                    </span>
                  </v-avatar>

                  <!-- Conteúdo -->
                  <div class="flex-grow-1 min-width-0">
                    <div class="d-flex align-center flex-wrap mb-2" style="gap: 8px">
                      <span class="font-weight-bold text-body-1 text--primary">
                        {{ feedback.isAnonymous ? 'Anônimo' : feedback.fromUserName }}
                      </span>
                      <v-chip x-small :color="feedback.type === 'PRAISE' ? '#4CAF50' : '#1E88E5'" dark class="font-weight-bold text-uppercase elevation-0 px-2" style="font-size: 10px;">
                        {{ getFeedbackTypeLabel(feedback.type) }}
                      </v-chip>
                      <v-chip v-for="skill in (feedback.skills || []).slice(0, 2)" :key="skill.id || skill.name" v-if="skill && skill.name" x-small outlined class="theme-chip-topic elevation-0">
                        {{ skill.name }}
                      </v-chip>
                      <v-spacer class="hidden-xs-only" />
                      <span class="text-caption text--secondary mr-2">{{ feedback.timeAgo }}</span>
                      <v-btn icon x-small color="grey" :disabled="isViewOnlyMode || deleting" @click="openDeleteDialog(feedback, 'received')">
                        <v-icon small>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>

                    <p class="text-body-2 text--primary mb-4" style="line-height: 1.6;">
                      {{ feedback.content }}
                    </p>

                    <!-- Área de Reações (Design Pills Style Clean) -->
                    <div class="d-flex align-center flex-wrap" style="gap: 8px">
                      <template v-if="feedback.reaction">
                        <div class="d-flex align-center flex-grow-1 flex-wrap" style="gap: 8px">
                          <v-btn
                            v-for="reaction in reactionOptions" :key="reaction.value"
                            small rounded class="text-none reaction-btn font-weight-bold"
                            :depressed="feedback.reaction === reaction.value"
                            :outlined="feedback.reaction !== reaction.value"
                            :color="feedback.reaction === reaction.value ? reaction.color : 'grey'"
                            :dark="feedback.reaction === reaction.value"
                            :disabled="isViewOnlyMode"
                            @click="toggleReaction(feedback, reaction.value)"
                          >
                            <v-icon left small>{{ reaction.icon }}</v-icon> {{ reaction.label }}
                          </v-btn>
                          <v-btn small text color="grey" class="text-none font-weight-bold ml-1" :disabled="isViewOnlyMode" @click="openReactionDialog(feedback)">
                            <v-icon small left>mdi-pencil-outline</v-icon> Editar
                          </v-btn>
                        </div>
                        <div class="d-flex align-center flex-shrink-0 mt-2 mt-sm-0">
                          <v-icon small color="#00E5FF" class="mr-1">mdi-check-circle-outline</v-icon>
                          <span class="text-caption font-weight-bold" style="color: #00E5FF">Você reagiu com '{{ getReactionLabel(feedback.reaction) }}'</span>
                        </div>
                      </template>

                      <template v-else>
                        <span class="text-caption text--secondary mr-2 mb-2 mb-sm-0">Como você se sente?</span>
                        <v-btn
                          v-for="reaction in reactionOptions" :key="reaction.value"
                          small outlined rounded color="grey"
                          class="text-none reaction-btn font-weight-bold hover-color-override mb-1 mb-sm-0"
                          :style="`--hover-color: ${reaction.color}`"
                          :disabled="isViewOnlyMode"
                          @click="toggleReaction(feedback, reaction.value)"
                        >
                          <v-icon left small>{{ reaction.icon }}</v-icon> {{ reaction.label }}
                        </v-btn>
                        <v-spacer class="hidden-xs-only" />
                        <v-btn small rounded outlined color="#00E5FF" class="text-none font-weight-bold ml-sm-2 responder-btn" :disabled="isViewOnlyMode" @click="openReactionDialog(feedback)">
                          Responder
                        </v-btn>
                      </template>
                    </div>

                    <!-- Comentário da Reação -->
                    <div v-if="feedback.reaction && feedback.recipientComment" class="mt-4 elevment-box pa-4 rounded-lg text-body-2 text--secondary font-italic feedback-comment">
                      "{{ feedback.recipientComment }}"
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <v-card v-else-if="!loadingReceived && receivedFeedbacks.length === 0" class="text-center py-12 elevment-card elevation-0">
              <v-icon size="64" color="rgba(128,128,128,0.2)">mdi-comment-off-outline</v-icon>
              <h3 class="text-h6 text--primary mt-4">Nenhum feedback recebido</h3>
              <p class="text-body-2 text--secondary">Você ainda não recebeu feedbacks.</p>
            </v-card>
            <v-card v-else-if="!loadingReceived && receivedFeedbacks.length > 0" class="text-center py-12 elevment-card elevation-0">
              <v-icon size="64" color="rgba(128,128,128,0.2)">mdi-filter-off-outline</v-icon>
              <h3 class="text-h6 text--primary mt-4">Nenhum resultado</h3>
              <p class="text-body-2 text--secondary">Ajuste os filtros para ver mais feedbacks.</p>
            </v-card>
          </v-tab-item>

          <!-- TAB 2: ENVIADOS -->
          <v-tab-item>
            <div v-if="loadingSent" class="text-center py-12 elevment-card elevation-0">
              <v-progress-circular indeterminate color="#00E5FF" size="48" width="3" />
              <p class="mt-4 text-body-2 text--secondary">Carregando feedbacks...</p>
            </div>

            <div v-else-if="filteredSentFeedbacks.length > 0">
              <!-- Card de Feedback Individual Solto -->
              <v-card
                v-for="feedback in filteredSentFeedbacks"
                :key="feedback.id"
                class="elevment-card elevation-0 mb-4 list-card"
              >
                <v-card-text class="pa-5 d-flex flex-column flex-sm-row">
                  <!-- Avatar -->
                  <v-avatar :color="feedback.type === 'PRAISE' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(30, 136, 229, 0.1)'" size="48" class="mr-4 mb-3 mb-sm-0 flex-shrink-0">
                    <v-img v-if="feedback.toUserAvatarUrl" :src="feedback.toUserAvatarUrl" :alt="feedback.toUserName" />
                    <span v-else class="font-weight-bold text-subtitle-1" :style="{ color: feedback.type === 'PRAISE' ? '#4CAF50' : '#1E88E5' }">
                      {{ getInitials(feedback.toUserName) }}
                    </span>
                  </v-avatar>

                  <!-- Conteúdo -->
                  <div class="flex-grow-1 min-width-0">
                    <div class="d-flex align-center flex-wrap mb-2" style="gap: 8px">
                      <span class="text-caption text--secondary">Para:</span>
                      <span class="font-weight-bold text-body-1 text--primary">{{ feedback.toUserName }}</span>
                      <v-chip x-small :color="feedback.type === 'PRAISE' ? '#4CAF50' : '#1E88E5'" dark class="font-weight-bold text-uppercase elevation-0 px-2" style="font-size: 10px;">
                        {{ getFeedbackTypeLabel(feedback.type) }}
                      </v-chip>
                      <v-chip v-if="feedback.isAnonymous" x-small outlined class="theme-chip-topic elevation-0">
                        <v-icon left x-small>mdi-incognito</v-icon> Anônimo
                      </v-chip>
                      <v-chip v-for="skill in (feedback.skills || []).slice(0, 2)" :key="skill.id || skill.name" v-if="skill && skill.name" x-small outlined class="theme-chip-topic elevation-0">
                        {{ skill.name }}
                      </v-chip>
                      <v-spacer class="hidden-xs-only" />
                      <span class="text-caption text--secondary mr-2">{{ feedback.timeAgo }}</span>
                      <v-btn icon x-small color="grey" :disabled="isViewOnlyMode || deleting" @click="openDeleteDialog(feedback, 'sent')">
                        <v-icon small>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>

                    <p class="text-body-2 text--primary mb-4" style="line-height: 1.6;">
                      {{ feedback.content }}
                    </p>

                    <!-- Reação do Recebedor -->
                    <div v-if="feedback.reaction" class="elevment-box d-flex flex-column pa-4 rounded-lg mt-2">
                        <div class="d-flex align-center">
                          <v-icon :color="getReactionColor(feedback.reaction)" size="20" class="mr-2">{{ getReactionIcon(feedback.reaction) }}</v-icon>
                          <span class="text-body-2 text--secondary flex-grow-1">
                            <strong>{{ feedback.toUserName }}</strong> reagiu com <strong :style="{ color: getReactionColorHex(feedback.reaction) }">{{ getReactionLabel(feedback.reaction) }}</strong>
                          </span>
                        </div>
                        <div v-if="feedback.recipientComment" class="mt-2 ml-7 text-body-2 text--secondary font-italic sent-feedback-comment">
                          "{{ feedback.recipientComment }}"
                        </div>
                    </div>
                    
                    <div v-if="!feedback.reaction" class="d-flex align-center py-1 mt-2">
                      <v-icon color="grey" size="16" class="mr-2">mdi-clock-outline</v-icon>
                      <span class="text-caption text--secondary">Aguardando reação...</span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <v-card v-else-if="!loadingSent && sentFeedbacks.length === 0" class="text-center py-12 elevment-card elevation-0">
              <v-icon size="64" color="rgba(128,128,128,0.2)">mdi-send-outline</v-icon>
              <h3 class="text-h6 text--primary mt-4">Nenhum feedback enviado</h3>
              <p class="text-body-2 text--secondary">Você ainda não enviou feedbacks para seus colegas.</p>
              <v-btn v-if="!isViewOnlyMode" color="#00E5FF" depressed height="40" class="mt-4 font-weight-bold black--text" style="border-radius: 8px;" @click="openSendDialog">
                <v-icon left>mdi-comment-plus-outline</v-icon> Enviar Primeiro
              </v-btn>
            </v-card>
            
            <v-card v-else-if="!loadingSent && sentFeedbacks.length > 0" class="text-center py-12 elevment-card elevation-0">
              <v-icon size="64" color="rgba(128,128,128,0.2)">mdi-filter-off-outline</v-icon>
              <h3 class="text-h6 text--primary mt-4">Nenhum resultado</h3>
              <p class="text-body-2 text--secondary">Ajuste os filtros para ver mais feedbacks.</p>
            </v-card>
          </v-tab-item>

        </v-tabs-items>
      </v-col>
    </v-row>

    <!-- Dialogs: Mantidos com estrutura premium intacta -->
    <v-dialog v-model="dialog" max-width="560px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-2 d-flex justify-space-between align-center">
          <div>
            <h3 class="text-h5 font-weight-bold text--primary">Enviar Feedback</h3>
            <p class="text-body-2 text--secondary mb-0">Compartilhe um elogio ou ponto de melhoria</p>
          </div>
          <v-btn icon color="grey" @click="closeDialog" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-0 mt-2">
          <v-form ref="form" v-model="formValid">
            <div class="mb-5 elevment-box d-flex rounded-lg pa-1">
              <v-btn
                :depressed="formData.type === 'PRAISE'"
                :text="formData.type !== 'PRAISE'"
                :color="formData.type === 'PRAISE' ? '#4CAF50' : 'grey'"
                :class="formData.type === 'PRAISE' ? 'white--text' : ''"
                class="text-none flex-grow-1 font-weight-bold type-toggle-btn"
                height="40"
                @click="formData.type = 'PRAISE'"
              >
                <v-icon left small>mdi-thumb-up-outline</v-icon> Elogio
              </v-btn>
              <v-btn
                :depressed="formData.type === 'IMPROVEMENT'"
                :text="formData.type !== 'IMPROVEMENT'"
                :color="formData.type === 'IMPROVEMENT' ? '#1E88E5' : 'grey'"
                :class="formData.type === 'IMPROVEMENT' ? 'white--text' : ''"
                class="text-none flex-grow-1 font-weight-bold type-toggle-btn"
                height="40"
                @click="formData.type = 'IMPROVEMENT'"
              >
                <v-icon left small>mdi-lightbulb-on-outline</v-icon> Melhoria
              </v-btn>
            </div>

            <v-autocomplete
              v-model="formData.toUserId" :items="availableUsers" item-text="name" item-value="id"
              placeholder="Para quem?" outlined dense prepend-inner-icon="mdi-account-outline"
              :rules="[rules.required]" hide-details="auto" class="elevment-input mb-4" color="#00E5FF"
            >
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center">
                  <v-avatar :color="item.avatarUrl ? 'transparent' : 'rgba(128,128,128,0.1)'" size="24" class="mr-2">
                    <v-img v-if="item.avatarUrl" :src="item.avatarUrl" :alt="item.name" />
                    <span v-else class="font-weight-bold text--primary" style="font-size: 10px">{{ getInitials(item.name) }}</span>
                  </v-avatar>
                  <span>{{ item.name }}</span>
                </div>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-avatar size="32">
                  <v-avatar :color="item.avatarUrl ? 'transparent' : 'rgba(128,128,128,0.1)'" size="32">
                    <v-img v-if="item.avatarUrl" :src="item.avatarUrl" :alt="item.name" />
                    <span v-else class="font-weight-bold text--primary" style="font-size: 12px">{{ getInitials(item.name) }}</span>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content><v-list-item-title>{{ item.name }}</v-list-item-title></v-list-item-content>
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-model="formData.relatedSkillIds" :items="skills" item-text="name" item-value="id"
              placeholder="Competência relacionada (opcional)" outlined dense multiple chips small-chips deletable-chips
              prepend-inner-icon="mdi-brain" hide-details="auto" class="elevment-input custom-chips mb-4" color="#00E5FF"
            />

            <v-textarea
              v-model="formData.content" placeholder="Escreva seu feedback aqui..."
              outlined rows="4" counter :rules="[rules.required, rules.minLength]"
              hide-details="auto" class="elevment-input mb-3" color="#00E5FF"
            />

            <div class="d-flex align-center py-2">
              <v-icon size="20" class="mr-2 text--secondary">mdi-incognito</v-icon>
              <span class="text-body-2 text--primary font-weight-medium flex-grow-1">Enviar anonimamente</span>
              <v-switch v-model="formData.isAnonymous" color="#00E5FF" inset dense hide-details class="mt-0 pt-0" />
            </div>
          </v-form>
        </v-card-text>

        <v-divider class="theme-divider mt-2" />
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn text height="40" class="font-weight-bold text--secondary px-4" style="border-radius: 8px;" @click="closeDialog">Cancelar</v-btn>
          <v-btn
            color="#00E5FF" depressed height="40" class="px-6 font-weight-bold black--text" style="border-radius: 8px;"
            :disabled="!formValid || isViewOnlyMode" :loading="sending" @click="sendFeedback"
          >
            <v-icon left>mdi-send</v-icon> Enviar Feedback
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reactionDialog" max-width="480px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-2 d-flex justify-space-between align-center">
          <div>
            <h3 class="text-h5 font-weight-bold text--primary">Reagir</h3>
            <p class="text-body-2 text--secondary mb-0">Como você se sente sobre este feedback?</p>
          </div>
          <v-btn icon color="grey" @click="closeReactionDialog" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-0 mt-2">
          <v-row dense class="mb-5">
            <v-col v-for="reaction in reactionOptions" :key="reaction.value" cols="6" class="pa-2">
              <div
                class="reaction-card-option elevment-box"
                :class="{ 'reaction-card-selected': reactionFormData.reaction === reaction.value }"
                @click="reactionFormData.reaction = reaction.value"
                :style="{ '--reaction-color': reaction.color }"
              >
                <div v-if="reactionFormData.reaction === reaction.value" class="reaction-check-badge" :style="{ backgroundColor: reaction.color }">
                  <v-icon color="white" size="12">mdi-check</v-icon>
                </div>
                <div class="text-center">
                  <v-icon :color="reaction.color" size="32">{{ reaction.icon }}</v-icon>
                  <p class="mb-0 mt-2 text-body-2 font-weight-bold" :style="{ color: reaction.color }">{{ reaction.label }}</p>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-textarea
            v-model="reactionFormData.comment" placeholder="Adicione um comentário (opcional)..."
            outlined rows="3" counter="200" maxlength="200" hide-details="auto"
            class="elevment-input" color="#00E5FF"
          />
        </v-card-text>

        <v-divider class="theme-divider mt-4" />
        <v-card-actions class="pa-6">
          <v-btn
            v-if="reactionFormData.feedbackId && receivedFeedbacks.find(f => f.id === reactionFormData.feedbackId)?.reaction"
            text color="error" height="40" class="font-weight-bold px-4" style="border-radius: 8px;"
            :disabled="isViewOnlyMode" @click="removeReaction"
          >
            <v-icon left small>mdi-delete-outline</v-icon> Remover
          </v-btn>
          <v-spacer />
          <v-btn text height="40" class="font-weight-bold text--secondary px-4" style="border-radius: 8px;" @click="closeReactionDialog">Cancelar</v-btn>
          <v-btn color="#00E5FF" depressed height="40" class="px-6 font-weight-bold black--text" style="border-radius: 8px;" :loading="reacting" :disabled="isViewOnlyMode" @click="saveReaction">
            <v-icon left>mdi-check</v-icon> Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="480px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4">
          <h3 class="text-h5 font-weight-bold error--text"><v-icon left color="error">mdi-delete-alert-outline</v-icon> Excluir Feedback</h3>
        </v-card-title>
        <v-card-text class="pa-6 pt-0">
          <p class="text-body-1 text--primary font-weight-medium mb-4">Atenção! Esta ação não pode ser desfeita.</p>
          <div v-if="feedbackToDelete" class="elevment-sub-box pa-4 rounded-lg feedback-to-delete-box">
            <p class="text-caption text--secondary mb-1">
              {{ deleteType === 'received' ? 'De:' : 'Para:' }}
              <strong class="text--primary">{{ deleteType === 'received' ? (feedbackToDelete.isAnonymous ? 'Anônimo' : feedbackToDelete.fromUserName) : feedbackToDelete.toUserName }}</strong>
            </p>
            <p class="text-body-2 text--primary mb-0 font-italic">"{{ feedbackToDelete.content }}"</p>
          </div>
        </v-card-text>
        <v-card-actions class="pa-6 pt-0">
          <v-spacer />
          <v-btn text height="40" class="font-weight-bold text--secondary" style="border-radius: 8px;" :disabled="deleting" @click="closeDeleteDialog">Cancelar</v-btn>
          <v-btn color="error" height="40" depressed class="px-6 font-weight-bold white--text" style="border-radius: 8px;" :loading="deleting" @click="confirmDelete">
            Excluir Feedback
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top class="font-weight-bold">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { FeedbacksService, UsersService, SkillsService } from '@/services'

export default {
  name: 'Feedbacks',

  data: () => ({
    activeTab: 0,
    loadingReceived: false,
    loadingSent: false,
    sending: false,
    reacting: false,
    deleting: false,
    dialog: false,
    reactionDialog: false,
    deleteDialog: false,
    formValid: false,
    feedbackToDelete: null,
    deleteType: null,

    receivedFeedbacks: [],
    sentFeedbacks: [],
    users: [],
    skills: [],

    receivedFilter: 'ALL',
    receivedSort: 'DESC',
    sentFilter: 'ALL',
    sentSort: 'DESC',

    formData: {
      toUserId: null,
      content: '',
      type: 'PRAISE',
      isAnonymous: false,
      relatedSkillIds: [],
    },

    reactionFormData: {
      feedbackId: null,
      reaction: null,
      comment: '',
    },

    reactionOptions: [
      { value: 'GRATEFUL',   label: 'Grato',      icon: 'mdi-heart',            color: '#E91E63' },
      { value: 'MOTIVATED',  label: 'Motivado',   icon: 'mdi-fire',             color: '#FF9800' },
      { value: 'THOUGHTFUL', label: 'Reflexivo',  icon: 'mdi-head-lightbulb',   color: '#9C27B0' },
      { value: 'INSPIRED',   label: 'Inspirado',  icon: 'mdi-star',             color: '#FFC107' },
    ],

    rules: {
      required: v => !!v || 'Campo obrigatório',
      minLength: v => (v && v.length >= 10) || 'Mínimo de 10 caracteres',
    },

    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success',
  }),

  computed: {
    receivedCount() { return this.receivedFeedbacks.length },
    sentCount() { return this.sentFeedbacks.length },
    receivedPraiseCount() { return this.receivedFeedbacks.filter(f => f.type === 'PRAISE').length },
    receivedImprovementCount() { return this.receivedFeedbacks.filter(f => f.type === 'IMPROVEMENT').length },
    sentPraiseCount() { return this.sentFeedbacks.filter(f => f.type === 'PRAISE').length },
    sentImprovementCount() { return this.sentFeedbacks.filter(f => f.type === 'IMPROVEMENT').length },

    activeTabFilter() { return this.activeTab === 0 ? this.receivedFilter : this.sentFilter },
    activeTabSort() { return this.activeTab === 0 ? this.receivedSort : this.sentSort },

    filteredReceivedFeedbacks() {
      let filtered = [...this.receivedFeedbacks]
      if (this.receivedFilter !== 'ALL') filtered = filtered.filter(f => f.type === this.receivedFilter)
      filtered.sort((a, b) => {
        const dateA = new Date(a.createdAt || 0)
        const dateB = new Date(b.createdAt || 0)
        return this.receivedSort === 'DESC' ? dateB - dateA : dateA - dateB
      })
      return filtered
    },

    filteredSentFeedbacks() {
      let filtered = [...this.sentFeedbacks]
      if (this.sentFilter !== 'ALL') filtered = filtered.filter(f => f.type === this.sentFilter)
      filtered.sort((a, b) => {
        const dateA = new Date(a.createdAt || 0)
        const dateB = new Date(b.createdAt || 0)
        return this.sentSort === 'DESC' ? dateB - dateA : dateA - dateB
      })
      return filtered
    },

    currentUser() {
      try {
        const userStr = localStorage.getItem('user')
        return userStr ? JSON.parse(userStr) : null
      } catch { return null }
    },

    availableUsers() {
      if (!this.currentUser) return this.users
      return this.users.filter(user => user.id !== this.currentUser.id)
    },

    isViewOnlyMode() {
      try { return this.$store?.state?.viewOnlyMode === true } catch { return false }
    }
  },

  mounted() {
    this.loadReceivedFeedbacks()
    this.loadSentFeedbacks()
    this.loadUsers()
    this.loadSkills()
  },

  methods: {
    async loadReceivedFeedbacks() {
      this.loadingReceived = true
      try {
        const response = await FeedbacksService.getReceived()
        this.receivedFeedbacks = response.data.map(f => ({ ...f, timeAgo: this.getTimeAgo(f.createdAt) }))
      } catch (error) {
        this.showSnackbar('Erro ao carregar feedbacks recebidos', 'error')
      } finally { this.loadingReceived = false }
    },

    async loadSentFeedbacks() {
      this.loadingSent = true
      try {
        const response = await FeedbacksService.getSent()
        this.sentFeedbacks = response.data.map(f => ({ ...f, timeAgo: this.getTimeAgo(f.createdAt) }))
      } catch (error) {
        this.showSnackbar('Erro ao carregar feedbacks enviados', 'error')
      } finally { this.loadingSent = false }
    },

    async loadUsers() {
      try {
        const response = await UsersService.list()
        this.users = response.data
      } catch (error) {}
    },

    async loadSkills() {
      try {
        const response = await SkillsService.list()
        this.skills = response.data
      } catch (error) {}
    },

    getUserName(userId) {
      if (!userId) return 'Usuário'
      const user = this.users.find(u => u.id === userId)
      return user ? user.name : 'Usuário'
    },

    getSkillNames(skillIds) {
      if (!skillIds || !Array.isArray(skillIds)) return []
      return skillIds.map(id => {
        const skill = this.skills.find(s => s.id === id)
        return skill ? skill.name : id
      })
    },

    getTimeAgo(createdAt) {
      if (!createdAt) return 'Recente'
      const diffMs = new Date() - new Date(createdAt)
      const diffMins = Math.floor(diffMs / 60000)
      const diffHours = Math.floor(diffMs / 3600000)
      const diffDays = Math.floor(diffMs / 86400000)
      
      if (diffMins < 1) return 'Agora'
      if (diffMins < 60) return `${diffMins}m atrás`
      if (diffHours < 24) return `${diffHours}h atrás`
      if (diffDays === 1) return 'Ontem'
      if (diffDays < 7) return `${diffDays}d atrás`
      return new Date(createdAt).toLocaleDateString('pt-BR')
    },

    getFeedbackTypeLabel(type) { return type === 'PRAISE' ? 'Elogio' : 'Melhoria' },
    
    getInitials(name) {
      if (!name) return '?'
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()
    },

    openSendDialog() {
      this.formData = { toUserId: null, content: '', type: 'PRAISE', isAnonymous: false, relatedSkillIds: [] }
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.$refs.form?.reset()
    },

    async sendFeedback() {
      if (!this.$refs.form.validate()) return
      this.sending = true
      try {
        await FeedbacksService.send(this.formData)
        const typeLabel = this.formData.type === 'PRAISE' ? 'Elogio' : 'Ponto de melhoria'
        this.showSnackbar(`${typeLabel} enviado com sucesso!`, 'success')
        this.closeDialog()
        this.loadSentFeedbacks()
      } catch (error) {
        this.showSnackbar('Erro ao enviar feedback', 'error')
      } finally { this.sending = false }
    },

    openReactionDialog(feedback) {
      this.reactionFormData = { feedbackId: feedback.id, reaction: feedback.reaction || null, comment: feedback.recipientComment || '' }
      this.reactionDialog = true
    },

    closeReactionDialog() {
      this.reactionDialog = false
      this.reactionFormData = { feedbackId: null, reaction: null, comment: '' }
    },

    async toggleReaction(feedback, reaction) {
      if (feedback.reaction === reaction) await this.removeReactionFromFeedback(feedback)
      else await this.quickReact(feedback, reaction)
    },

    async quickReact(feedback, reaction) {
      try {
        await FeedbacksService.react(feedback.id, { reaction, comment: feedback.recipientComment || null })
        const index = this.receivedFeedbacks.findIndex(f => f.id === feedback.id)
        if (index > -1) {
          this.receivedFeedbacks[index].reaction = reaction
          this.receivedFeedbacks[index].reactedAt = new Date().toISOString()
        }
        this.showSnackbar('Reação atualizada!', 'success')
      } catch (error) {
        this.showSnackbar('Erro ao salvar reação', 'error')
      }
    },

    async removeReactionFromFeedback(feedback) {
      try {
        await FeedbacksService.react(feedback.id, { reaction: null, comment: null })
        const index = this.receivedFeedbacks.findIndex(f => f.id === feedback.id)
        if (index > -1) {
          this.receivedFeedbacks[index].reaction = null
          this.receivedFeedbacks[index].recipientComment = null
          this.receivedFeedbacks[index].reactedAt = null
        }
        this.showSnackbar('Reação removida', 'info')
      } catch (error) {
        this.showSnackbar('Erro ao remover reação', 'error')
      }
    },

    async removeReaction() {
      if (!this.reactionFormData.feedbackId) return
      const feedback = this.receivedFeedbacks.find(f => f.id === this.reactionFormData.feedbackId)
      if (!feedback) return
      this.reacting = true
      try {
        await this.removeReactionFromFeedback(feedback)
        this.closeReactionDialog()
      } finally { this.reacting = false }
    },

    async saveReaction() {
      if (!this.reactionFormData.reaction) return this.showSnackbar('Selecione uma reação', 'warning')
      this.reacting = true
      try {
        await FeedbacksService.react(this.reactionFormData.feedbackId, { reaction: this.reactionFormData.reaction, comment: this.reactionFormData.comment || null })
        const index = this.receivedFeedbacks.findIndex(f => f.id === this.reactionFormData.feedbackId)
        if (index > -1) {
          this.receivedFeedbacks[index].reaction = this.reactionFormData.reaction
          this.receivedFeedbacks[index].recipientComment = this.reactionFormData.comment
          this.receivedFeedbacks[index].reactedAt = new Date().toISOString()
        }
        this.showSnackbar('Reação salva!', 'success')
        this.closeReactionDialog()
      } catch (error) {
        this.showSnackbar('Erro ao salvar reação', 'error')
      } finally { this.reacting = false }
    },

    getReactionLabel(reaction) { return this.reactionOptions.find(r => r.value === reaction)?.label || reaction },
    getReactionIcon(reaction) { return this.reactionOptions.find(r => r.value === reaction)?.icon || 'mdi-emoticon' },
    getReactionColor(reaction) { return this.reactionOptions.find(r => r.value === reaction)?.color || 'grey' },
    getReactionColorHex(reaction) { return this.getReactionColor(reaction) },

    showSnackbar(text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    },

    setActiveFilter(value) {
      if (this.activeTab === 0) this.receivedFilter = value
      else this.sentFilter = value
    },

    toggleActiveSort() {
      if (this.activeTab === 0) this.receivedSort = this.receivedSort === 'DESC' ? 'ASC' : 'DESC'
      else this.sentSort = this.sentSort === 'DESC' ? 'ASC' : 'DESC'
    },

    openDeleteDialog(feedback, type) {
      this.feedbackToDelete = feedback
      this.deleteType = type
      this.deleteDialog = true
    },

    closeDeleteDialog() {
      this.deleteDialog = false
      this.feedbackToDelete = null
      this.deleteType = null
    },

    async confirmDelete() {
      if (!this.feedbackToDelete) return
      this.deleting = true
      try {
        await FeedbacksService.delete(this.feedbackToDelete.id)
        if (this.deleteType === 'received') {
          const idx = this.receivedFeedbacks.findIndex(f => f.id === this.feedbackToDelete.id)
          if (idx > -1) this.receivedFeedbacks.splice(idx, 1)
        } else {
          const idx = this.sentFeedbacks.findIndex(f => f.id === this.feedbackToDelete.id)
          if (idx > -1) this.sentFeedbacks.splice(idx, 1)
        }
        this.showSnackbar('Feedback excluído!', 'success')
        this.closeDeleteDialog()
      } catch (error) {
        this.showSnackbar('Erro ao excluir feedback', 'error')
      } finally { this.deleting = false }
    },
  },
}
</script>

<style scoped>
/* Fundo Global Premium */
.dashboard-container {
  max-width: 1440px;
  margin: 0 auto;
}

/* Base Cards Independentes e Soltos (Visual Limpo) */
.elevment-card {
  border-radius: 16px !important;
  border: 1px solid var(--border-color, rgba(128,128,128,0.15)) !important;
  background-color: var(--bg-card, #1A1A1A) !important;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.list-card:hover {
  transform: translateY(-2px);
  border-color: rgba(128,128,128,0.25) !important;
}

/* Cards do Topo */
.top-card {
  min-height: 120px;
}
.text-h1 {
  font-size: 4rem;
  line-height: 1;
}

/* Base Dialogs & Boxes */
.elevment-dialog-card {
  border-radius: 16px !important;
  border: 1px solid var(--border-color, rgba(128,128,128,0.15)) !important;
  background-color: var(--bg-card, #1A1A1A) !important;
}

.elevment-box {
  background-color: var(--bg-secondary, rgba(128,128,128,0.05));
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(128,128,128,0.1));
}

.theme-divider {
  border-color: var(--border-color, rgba(128,128,128,0.15)) !important;
}

/* Torna o fundo do tabs items transparente para os cards flutuarem no fundo preto global */
::v-deep .transparent-bg,
::v-deep .v-window {
  background-color: transparent !important;
}

/* Chips Tópicos */
::v-deep .theme-chip-topic {
  border-radius: 9999px !important;
  background: transparent !important;
  border: 1px solid var(--border-color, rgba(128,128,128,0.2)) !important;
  color: var(--text-secondary, #AEAEB2) !important;
}
::v-deep .custom-chips .v-chip { border-radius: 6px !important; }

/* ====================================================
   Tabs Segmentadas (Fundo totalmente ciano quando ativado)
   ==================================================== */
.segmented-tabs {
  background-color: rgba(255, 255, 255, 0.05) !important;
  border-radius: 10px;
  padding: 4px;
}

.custom-tab-btn {
  border-radius: 8px !important;
  margin: 0 4px;
  border: 1px solid transparent !important;
  color: #86868B !important;
  transition: all 0.3s ease;
}

/* Estado Ativo = Totalmente Ciano, Texto Preto */
::v-deep .v-tabs .v-tab--active,
.custom-tab-active {
  background-color: #00E5FF !important;
  border: 1px solid #00E5FF !important;
  color: #000000 !important;
}

::v-deep .v-tab::before {
  display: none !important;
}

/* Filter Pills (Abaixo ou ao lado das abas) */
.active-filter-pill {
  background-color: rgba(0, 229, 255, 0.1) !important;
  color: #00E5FF !important;
  border: 1px solid rgba(0, 229, 255, 0.3) !important;
}
.inactive-filter-pill {
  background-color: transparent !important;
  color: var(--text-secondary, #AEAEB2) !important;
  border: 1px solid rgba(128,128,128,0.2) !important;
}
.inactive-filter-pill:hover {
  background-color: var(--bg-secondary, rgba(128,128,128,0.05)) !important;
}

/* Reactions Buttons no Card */
.reaction-btn { border-color: var(--border-color, rgba(128,128,128,0.2)) !important; }
.hover-color-override:hover {
  border-color: var(--hover-color) !important;
  color: var(--hover-color) !important;
  background-color: rgba(128,128,128,0.05);
}

/* Reactions Select Dialog */
.reaction-card-option {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  height: 90px;
  border-radius: 12px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}
.reaction-card-option:hover {
  border-color: var(--reaction-color);
  background-color: rgba(128,128,128,0.02);
}
.reaction-card-selected {
  border-color: var(--reaction-color) !important;
  background-color: rgba(128,128,128,0.05) !important;
  transform: scale(1.02);
}
.reaction-check-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.type-toggle-btn { border-radius: 6px !important; }
</style>